import styled, { css } from 'styled-components';
import { DropdownListItem, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from "core/modules";

export const SearchBarHolder = styled(FlexBox)``;

export const ProjectSearchBarRoot = styled(FlexBox)`
    font-size: 15px;
    line-height: 20px;
    column-gap: 7px;
    min-height: 24px;
    border: ${({ theme }) => theme.sortByBorder};
    background: ${({ theme }) => theme.sortByBg};
    white-space: nowrap;
    ${DropdownListItem} {
        font-size: 15px;
        line-height: 20px;
        background: ${({ theme }) => theme.mainDropdownStyles.bg};
      
        div {
          color: ${({ theme }) => theme.mainDropdownStyles.color};

          .active {
            color: ${({ theme }) => theme.mainDropdownStyles.colorActive};
          }
        }

        &:hover {
          background: ${({ theme }) => theme.mainDropdownStyles.hoverBG};

          div {
            color: ${({ theme }) => theme.mainDropdownStyles.color};
          }
        }
    }

    .dropdown-element-popup {
      background: ${({ theme }) => theme.mainDropdownStyles.bg};
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      .dropdown-button {
        display: flex;
        align-items: center;
      }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      .dropdown-button {
        display: flex;
        align-items: center;
      }

      width: 100%;
      justify-content: space-between;
    }
`

export const HoverItemWithSvg = styled(FInter.SmallTextFlex)`
    svg {
        opacity: 0.47;
        transition: opacity 0.2s;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const SortSmallTextDiv = styled(FInter.SmallTextDiv)`
    font-size: 17px;
    line-height: 22px;
    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 15px;
      line-height: 20px;
    }
`

export const HoverItemText = styled(FInter.SmallText)<{ nowrap?: boolean }>`
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  white-space: ${p => p.nowrap ? 'nowrap' : 'normal'};
  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const SearchBarWrapper = styled(FlexBox)<{inLine?: boolean }>`
    flex-grow: 0;
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        place-items: flex-start;

        ${p => p?.inLine ? css`
            flex-flow: row;
            place-items: flex-start;

            * {
                margin-right: 0 !important;
            }

            ${SearchBarHolder} {
                max-width:inherit;
                width: auto;
            }
        ` : null}
    }
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
          margin-left: auto;
    }
`;


export const Checkboxes = styled.div<{isAnyChecked?: boolean, circleColor?: string}>`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 999;
  .sortbar-checkbox-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 2px;
    border-radius: 3px;
    border: 1px solid var(--Gallllery-Black31, #B6B6B5);
    position: relative;
    :hover {
        border: 1px solid #545453;
        svg {
          path {
            fill: #545453;
          };
        }
    }
    ::after {
      content: '';
      position: absolute;
      top: -4px;
      right: -4px;
      display: ${p => p.isAnyChecked? 'flex' : 'none'};
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: ${p => p.circleColor || '#ff0000'};
    }
  }
  svg {
    width: 24px;
    height: 24px;
  }
  div {
    :hover {
      cursor: pointer;
    }
  }
  @media (max-width: 1199px) {
    margin-right: 8px;
    .sortbar-checkbox-icon-wrapper {
      border: none;
      :hover {
          border: none;
      }
      ::after {
          top: 3px;
          right: 1px;
      }
    }
  }
  @media (max-width: 743px) {
    z-index: 3;
  }
`

export const CheckboxesDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.mainDropdownStyles.bg || '#f2f2f2'};
  border-radius: 3px;
  position: absolute;
  z-index: 9998;
  width: fit-content;
  min-width: 240px;
  top: 36px;
  right: 0;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  
  @media (max-width: 743px) {
    left: 0;
    transform: none;
  }
`

export const CheckboxesDropdownItem = styled(FlexBox)`
  padding: 12px 16px;
  border-radius: 3px;

  &, & div {
    background: ${(p) => p.theme.mainDropdownStyles.bg || '#f2f2f2'};
  }
  
`
import styled, { css } from 'styled-components';
import { DropdownListItem, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from "core/modules";

export const SearchBarHolder = styled(FlexBox)``;

export const ProjectSearchBarRoot = styled(FlexBox)`
    font-size: 15px;
    line-height: 20px;
    column-gap: 7px;
    min-height: 24px;
    border: ${({ theme }) => theme.sortByBorder};
    background: ${({ theme }) => theme.sortByBg};
    white-space: nowrap;
    ${DropdownListItem} {
        font-size: 15px;
        line-height: 20px;
        background: ${({ theme }) => theme.mainDropdownStyles.bg};
      
        div {
          color: ${({ theme }) => theme.mainDropdownStyles.color};

          .active {
            color: ${({ theme }) => theme.mainDropdownStyles.colorActive};
          }
        }

        &:hover {
          background: ${({ theme }) => theme.mainDropdownStyles.hoverBG};

          div {
            color: ${({ theme }) => theme.mainDropdownStyles.color};
          }
        }
    }

    .dropdown-element-popup {
      background: ${({ theme }) => theme.mainDropdownStyles.bg};
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      .dropdown-button {
        display: flex;
        align-items: center;
      }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      .dropdown-button {
        display: flex;
        align-items: center;
      }

      width: 100%;
      justify-content: space-between;
    }
`

export const HoverItemWithSvg = styled(FInter.SmallTextFlex)`
    svg {
        opacity: 0.47;
        transition: opacity 0.2s;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const SortSmallTextDiv = styled(FInter.SmallTextDiv)`
    font-size: 17px;
    line-height: 22px;
    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 15px;
      line-height: 20px;
    }
`

export const HoverItemText = styled(FInter.SmallText)<{ nowrap?: boolean }>`
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  white-space: ${p => p.nowrap ? 'nowrap' : 'normal'};
  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const SearchBarWrapper = styled(FlexBox)<{inLine?: boolean }>`
    flex-grow: 0;
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        place-items: flex-start;

        ${p => p?.inLine ? css`
            flex-flow: row;
            place-items: flex-start;

            * {
                margin-right: 0 !important;
            }

            ${SearchBarHolder} {
                max-width:inherit;
                width: auto;
            }
        ` : null}
    }
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
          margin-left: auto;
    }
`;


export const Checkboxes = styled.div<{isAnyChecked?: boolean, circleColor?: string}>`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 999;
  .sortbar-checkbox-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 2px;
    border-radius: 3px;
    border: 1px solid var(--Gallllery-Black31, #B6B6B5);
    position: relative;
    :hover {
        border: 1px solid #545453;
        svg {
          path {
            fill: #545453;
          };
        }
    }
    ::after {
      content: '';
      position: absolute;
      top: -4px;
      right: -4px;
      display: ${p => p.isAnyChecked? 'flex' : 'none'};
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: ${p => p.circleColor || '#ff0000'};
    }
  }
  svg {
    width: 24px;
    height: 24px;
  }
  div {
    :hover {
      cursor: pointer;
    }
  }
  @media (max-width: 1199px) {
    margin-right: 8px;
    .sortbar-checkbox-icon-wrapper {
      border: none;
      :hover {
          border: none;
      }
      ::after {
          top: 3px;
          right: 1px;
      }
    }
  }
  @media (max-width: 743px) {
    z-index: 3;
  }
`

export const CheckboxesDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.mainDropdownStyles.bg || '#f2f2f2'};
  border-radius: 3px;
  position: absolute;
  z-index: 9998;
  width: fit-content;
  min-width: 240px;
  top: 36px;
  right: 0;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  
  @media (max-width: 743px) {
    left: 0;
    transform: none;
  }
`

export const CheckboxesDropdownItem = styled(FlexBox)`
  padding: 12px 16px;
  border-radius: 3px;

  &, & div {
    background: ${(p) => p.theme.mainDropdownStyles.bg || '#f2f2f2'};
  }
  
`
